import useIsAIQuotaExhausted from './useIsAIQuotaExhausted';

type PracticeTutorQuota = {
  isQuotaExhausted: boolean;
};

/**
 * Whether the exercise can still hand the student over to the tutor. It never requests the quota:
 * the provider reads it on mount and the engine reports it after every turn, so a second read on
 * every exercise mount would only repeat the request.
 */
function usePracticeTutorQuota(): PracticeTutorQuota {
  return { isQuotaExhausted: useIsAIQuotaExhausted() };
}

export default usePracticeTutorQuota;
